import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = '查看全部' }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-7">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="h-6 w-1.5 rounded-full bg-primary-500" aria-hidden="true"></span>
          <h2 className="text-xl font-bold text-foreground-900 md:text-2xl">{title}</h2>
        </div>
        {subtitle && <p className="mt-1.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-xs font-medium text-primary-600 hover:bg-primary-100 hover:text-primary-700 md:text-sm"
        >
          {moreLabel}
          <i className="ri-arrow-right-line h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}